import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {SuccessService} from "./success.service";
import {Snackbar} from "../../shared/utils/snackbar.utils";

@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss']
})
export class SuccessComponent implements OnInit {

  hoje = new Date();
  constructor(
    private route: ActivatedRoute,
    private readonly service: SuccessService,
    private readonly snackbar: Snackbar
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const empresaId = params['empresaId'];
      this.service.validate(empresaId).subscribe({
        next: () => {
          this.snackbar.openSnackBar('Pagamento concluido com sucesso.', 'X', false);
        },
        error: erro => {
          this.snackbar.openSnackBar('Erro Interno.', 'X', true);
        }
      });
    });
  }

}
